import ApplicationAdapter from 'lumen/adapters/application';

export default class DesiredCompsetAdapter extends ApplicationAdapter {
  pathForType(modelName: string): string {
    // This is for calling `query` with `typeKey: 'benchmarkinsight/competitors/proposed-compset'`
    // By default, Ember Data will pluralise the key and call `/benchmarkinsight/competitors/proposed-compsets`.
    // We want to call `/benchmarkinsight/competitors/proposed-compset` instead, so we need to overwrite the path here.
    return modelName;
  }
}
